// Тонкий wrapper над @vueuse/core useMediaQuery — оставлен ради
// единственной публичной точки входа useIsDesktop() и константы DESKTOP_MQ,
// которыми пользуются 4 компонента. Сам useMediaQuery реэкспортируется,
// чтобы новый код мог импортировать как раньше: import { useMediaQuery }
// from '@/composables/useMediaQuery'.
import { useMediaQuery } from '@vueuse/core'

export { useMediaQuery }

export const DESKTOP_MQ = '(min-width: 900px)'

// Tailwind sm — тот же порог, на котором DialogContent переключает
// bottom-sheet (< sm) / центр (≥ sm). Внутри модалок: узкий ввод (SegmentedControl,
// Select) на мобилке ↔ развёрнутый (кнопки-иконки ChoiceBtn) на десктопе.
export const SM_MQ = '(min-width: 640px)'

// Tailwind md — граница mobile/desktop layout (таб-бар, FAB, floating tabs).
export const MD_MQ = '(min-width: 768px)'

// Tailwind xl — граница появления aside-колонки AppPage (до xl aside скрыт,
// страница показывает его содержимое своей шторкой).
export const XL_MQ = '(min-width: 1280px)'

// Порог архетипа DeskSplit «мастер + деталь» (пользователи/заявки/структура): ниже —
// мобильная проекция (список → карточка/шторка), выше — две панели. lg (1024) —
// стандартный Tailwind-брейк: раньше был кастомный 1200, т.к. полный сайдбар 256px
// душил деталь-панель ниже 1200. Теперь сайдбар на < xl (1280) схлопывается в rail
// (AppSidebar) и отдаёт место — split спокойно живёт с lg=1024 без костыля.
export const SPLIT_MQ = '(min-width: 1024px)'

// Тач-устройства: фокус-политика (v-autofocus, диалоги) — см. frontend-page-layout.
export const COARSE_POINTER_MQ = '(pointer: coarse)'

export function useIsDesktop() {
  return useMediaQuery(DESKTOP_MQ)
}
